import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-ac5ba7f6-728b-4e94-943a-d2df8822cd4d-__Layer_1",
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M 985.004 176.744 L 847.365 39.056 C 795.173 -13.019 710.678 -13.019 658.487 39.056 L 508.9 188.692 C 494.663 202.919 494.663 225.995 508.9 240.222 L 783.936 515.258 C 798.135 529.515 821.218 529.515 835.417 515.258 L 985.004 365.622 C 1037.187 313.476 1037.187 228.891 985.004 176.744 Z",
      fill: "#145638"
    }, null, -1),
    _createElementVNode("path", {
      d: "M 835.417 463.922 L 560.187 188.692 C 545.976 174.461 522.915 174.461 508.705 188.692 L 68.638 628.711 C 49.27 648.02 36.33 672.832 31.581 699.765 L 1.955 867.031 C -12.583 948.893 50.38 1024.011 133.523 1024 C 141.357 1024.003 149.175 1023.304 156.884 1021.911 L 324.344 992.14 C 351.262 987.349 376.063 974.414 395.398 955.083 L 835.417 515.064 C 849.653 500.837 849.653 477.761 835.417 463.534 L 835.417 463.922 Z",
      fill: "#00aa5b"
    }, null, -1)
  ]))]))
}
export default { render: render }